import { render, staticRenderFns } from "./RegistDevice.vue?vue&type=template&id=66c5ec93&"
import script from "./RegistDevice.vue?vue&type=script&lang=js&"
export * from "./RegistDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports